import Loading from "@lhd/components/Loading";
import {
  AppPartType,
  ItemConfigDataType,
  SelectionValue,
  SubmitItemType,
} from "@lhd/features/Apps/AppForm/types";
import {
  useEditApps,
  useFetchOneApp,
  useFetchOrgs,
  useFetchPrefectures,
  useFetchRecord,
} from "@lhd/hooks";
import { AppSelectionList } from "@lhd/types";
import { Button, Form, notification } from "antd";
import { cloneDeep, flatMapDeep, get, isEmpty, isNumber, pick } from "lodash";
import moment from "moment";
import { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useMatch, useNavigate } from "react-router-dom";
import { calculatedValue } from "../AppForm/components/Modal/SettingComponents/CalculatedSetting/hook";
import { APP_PART_TYPES, COLUMN_WIDTH, ROW_HEIGHT } from "../AppForm/constants";
import {
  ensureCurrentOptionsJson,
  getPrimaryCompanyNameDisplayText,
} from "../utils";
import Attachment from "../components/Attactment";
import AutoFill from "../components/AutoFill";
import EmployeeInfoChildField from "../components/EmployeeInfoChildField";
import Calculated from "../components/Calculated";
import CheckBox from "../components/CheckBox";
import EmployeeSignature from "../components/EmployeeSignature";
import CommonChoose from "../components/CommonChoose";
import CommonSelection from "../components/CommonSelection";
import DateAndTime from "../components/DateAndTime";
import DateCustom from "../components/DateCustom";
import Dropdown from "../components/Dropdown";
import HorizontalBorder from "../components/HorizontalBorder";
import InputNumber from "../components/InputNumber";
import LabelField from "../components/LabelField";
import LinkCusTom from "../components/LinkCusTom";
import RadioButton from "../components/RadioButton";
import RichText from "../components/RichText";
import TableCusTom from "../components/TableCusTom";
import Text from "../components/Text";
import TextAreaCustom from "../components/TextAreaCustom";
import TimeCustom from "../components/TimeCustom";
import VerticalBorder from "../components/VerticalBorder";
import {
  getClientsOptions,
  getCompanyPhoneNumbersOptions,
  getPositionsOptions,
  getLayoutWithMarginTop,
  getMinXAndMarginLeft,
  getNameCompanyLocation,
  getOrgsData,
  getWorkers,
  groupItemsByRow,
  groupItemsCol,
  stringifyEmployeeInfoValue,
  isEmployeeInfoChildAppPartType,
  isEmployeeInfoChildCurrentOptionsKey,
  getEmployeeInfoChildCurrentOptionsKey,
  stringifyEmployeeInfoChildFormValue,
} from "../utils";
import { Styles, StyledButton } from "./styled";
import { isEqualTime } from "./validate";
import { useSubmitFormState } from "@lhd/components/FormState/hook";
import { MENU_COLORS, SERVICES } from "@lhd/constants";
import axiosV2 from "@lhd/libs/axiosV2";
import { getCompanyId } from "@lhd/utility";
import dayjs from "dayjs";

type Error = {
  name: string;
  errors: string[];
};

type TOption = {
  text: string;
  value: number | string;
};

export const defaultOptionDropdown: TOption = {
  text: "----",
  value: "----",
};

const listSelection: string[] = [
  APP_PART_TYPES.ORGANIZATION_SELECTION,
  APP_PART_TYPES.DIVISION_SELECTION,
  APP_PART_TYPES.DEPARTMENT_SELECTION,
  APP_PART_TYPES.BRANCH_SELECTION,
  APP_PART_TYPES.WORKER_SELECTION,
  APP_PART_TYPES.EMPLOYEE_INFO_SELECTION,
  APP_PART_TYPES.COMPANY_LOCATION_SELECTION,
  APP_PART_TYPES.REPRESENTATIVE_SELECTION,
  APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION,
];

const AppCreate: FC<Record<string, unknown>> = ({ layout, isPreview }) => {
  moment.updateLocale("en", {
    weekdaysShort: [
      "日曜日",
      "月曜日",
      "火曜日",
      "水曜日",
      "木曜日",
      "金曜日",
      "土曜日",
    ],
  });

  const match = useMatch("/apps/:id/records/create");
  const dataApp = useFetchOneApp(match?.params.id);
  const { data, refetch } = isPreview
    ? {
        data: {
          app_parts: layout as AppPartType[],
        },
        refetch: () => {},
      }
    : dataApp;

  const navigate = useNavigate();
  const { mutate, isLoading } = useEditApps(match?.params.id as string);
  const [listFileUploaded, setListFileUploaded] = useState<any>([]);
  const [form] = Form.useForm();
  const [editorState, setEditorState] = useState<SubmitItemType[]>([]);
  const { data: fetRecordData } = useFetchRecord(match?.params.id);
  const recordData = fetRecordData?.data;
  const [dataSource, setDataSource] = useState<any>();
  const [idTableEmpty, setIdTableEmpty] = useState<{ id: string }>({ id: "" });
  const [allowDownLoad, setAllowDownLoad] = useState<{
    [key: string]: boolean;
  }>({});
  const [isUploadingFiles, setIsUploadingFiles] = useState(false);
  const uploadingFilesRef = useRef<Set<string>>(new Set());

  const requiredFieldNames = useMemo(() => {
    if (!data?.app_parts) return [];
    return data.app_parts
      .filter(
        (item) =>
          item.is_required_field === true &&
          item.app_part_type !== APP_PART_TYPES.CALCULATED &&
          item.app_part_type !== APP_PART_TYPES.CREATED_BY &&
          item.app_part_type !== APP_PART_TYPES.UPDATED_BY &&
          item.app_part_type !== APP_PART_TYPES.LOOKUP &&
          item.app_part_type !== APP_PART_TYPES.CREATED_DATETIME &&
          item.app_part_type !== APP_PART_TYPES.UPDATED_DATETIME &&
          item.app_part_type !== APP_PART_TYPES.RECORD_NUMBER &&
          item.app_part_type !== APP_PART_TYPES.EMPLOYEE_SIGNATURE,
      )
      .map((item) => item.id?.toString())
      .filter((id): id is string => Boolean(id));
  }, [data?.app_parts]);
  const {
    buttonState,
    getButtonStyle,
    registerFormWatcher,
    markSubmit,
    getFieldClassName,
    getFieldChildClassName,
  } = useSubmitFormState(form, false, requiredFieldNames);

  const newLayout = useMemo(() => {
    if (!data?.app_parts) return [];
    const layoutSorted = cloneDeep(data.app_parts).sort((a, b) => {
      return (
        a.item_config_data.h +
        a.item_config_data.y -
        (b.item_config_data.h + b.item_config_data.y)
      );
    });

    const layoutItem =
      layoutSorted?.map((item) => {
        const item_config_data = item.item_config_data;
        return {
          ...item,
          item_config_data: {
            ...item_config_data,
            yBottom: item_config_data.h + item_config_data.y,
          },
        };
      }) || [];

    const newLayoutByRow = groupItemsByRow([...layoutItem]);
    const layoutWithMarginTop = getLayoutWithMarginTop(newLayoutByRow);
    return layoutWithMarginTop.map((x) => ({
      ...x,
      items: groupItemsCol(x.items),
    }));
  }, [data]);

  const getIdFromUrlAttactment = (url: string) => url.split("/")[6];

  useEffect(() => {
    if (idTableEmpty) {
      handleAddRow(idTableEmpty.id);
    }
  }, [idTableEmpty]);

  const [selectionDataList, setSelectionDataList] = useState<AppSelectionList>({
    branch_selection: undefined,
    department_selection: undefined,
    division_selection: undefined,
    worker_selection: undefined,
    organization_selection: undefined,
    company_location_selection: undefined,
    representative_selection: undefined,
    company_phone_number_selection: undefined,
    position_selection: undefined,
    customer_selection: undefined,
  });
  const { data: listOrg } = useFetchOrgs();
  const { data: prefecturesData } = useFetchPrefectures();

  const listSelectionNeedCall = useMemo(() => {
    const result: any = {};
    const getListSelectionNeedCall = (app_parts: AppPartType[]) => {
      app_parts?.forEach((app_part) => {
        if (
          Object.prototype.hasOwnProperty.call(
            selectionDataList,
            app_part.app_part_type,
          )
        ) {
          result[app_part.app_part_type] = true;
        } else if (
          app_part.app_part_type === APP_PART_TYPES.EMPLOYEE_INFO_SELECTION ||
          app_part.app_part_type === APP_PART_TYPES.EMPLOYEE_SIGNATURE
        ) {
          result[APP_PART_TYPES.WORKER_SELECTION] = true;
        } else if (app_part.app_part_type === APP_PART_TYPES.TABLE) {
          getListSelectionNeedCall(app_part?.children || []);
        }
      });
    };

    getListSelectionNeedCall(data?.app_parts || []);
    return result;
  }, [data]);

  const flattenDeepArray: any = useCallback((originalArray: any) => {
    return flatMapDeep(originalArray, (item) => {
      const transformedItem = pick(item, ["id", "name"]);
      const children = item.children || [];

      return [transformedItem, ...flattenDeepArray(children)];
    });
  }, []);

  const getDataByOrgType = useCallback(
    async (type: string) => {
      const listId =
        listOrg?.data
          ?.filter((org) => org.org_type === type)
          ?.map((orgItem) => orgItem?.id) ?? [];
      const arrData = await Promise.all(
        listId.map(async (id) => await getOrgsData(id)),
      );

      const mergedArray = arrData.reduce(
        (prevArr, arrItem) => [...prevArr, ...arrItem],
        [],
      );

      return flattenDeepArray(mergedArray);
    },
    [flattenDeepArray, listOrg?.data],
  );

  const getSelectionData = useCallback(async () => {
    const list = { ...selectionDataList };
    if (
      isEmpty(listSelectionNeedCall) ||
      !Object.keys(listSelectionNeedCall).every((key) => {
        return (list as any)[key] === undefined;
      })
    )
      return;

    if (!list.worker_selection && listSelectionNeedCall.worker_selection) {
      const workersData = await getWorkers();
      list.worker_selection = workersData;
    }

    if (!list.division_selection && listSelectionNeedCall.division_selection) {
      const divisionData = await getDataByOrgType("division");
      list.division_selection = divisionData;
    }

    if (
      !list.organization_selection &&
      listSelectionNeedCall.organization_selection
    ) {
      const organizationData = await getDataByOrgType("chairman");
      list.organization_selection = organizationData;
    }

    if (!list.branch_selection && listSelectionNeedCall.branch_selection) {
      const branchData = await getDataByOrgType("branch");
      list.branch_selection = branchData;
    }

    if (
      !list.department_selection &&
      listSelectionNeedCall.department_selection
    ) {
      const departmentData = await getDataByOrgType("department");
      list.department_selection = departmentData;
    }

    if (
      !list.company_location_selection &&
      listSelectionNeedCall.company_location_selection
    ) {
      try {
        const companyId = getCompanyId();
        const res = await axiosV2.get(SERVICES.COMPANY_LOCATIONS, {
          params: { company_id: companyId, per_page: 1000 },
        });
        const activeLocations = (res.data || []).map((loc: any) => {
          return {
            id: loc.id,
            name: getNameCompanyLocation(loc, prefecturesData) || "未設定",
          };
        });
        list.company_location_selection = activeLocations;
      } catch (e) {
        list.company_location_selection = [];
      }
    }

    if (
      !list.representative_selection &&
      listSelectionNeedCall.representative_selection
    ) {
      try {
        const companyId = getCompanyId();
        const workersData = list.worker_selection || (await getWorkers());
        list.worker_selection = workersData;
        const res = await axiosV2.get(SERVICES.COMPANY_LEADERSHIPS, {
          params: { company_id: companyId, per_page: 1000 },
        });
        const activeLeaderships = res.data || [];
        const repOptions = activeLeaderships.map((lead: any) => {
          const worker = (workersData || []).find(
            (w: any) => Number(w.id) === Number(lead.worker_id),
          );
          const officerName = worker
            ? worker.first_name && worker.last_name
              ? `${worker.first_name} ${worker.last_name}`
              : worker.full_name || worker.name
            : `Worker #${lead.worker_id}`;
          return {
            id: lead.worker_id,
            name: officerName,
            full_name: officerName,
            first_name: worker?.first_name || "",
            last_name: worker?.last_name || "",
          };
        });
        list.representative_selection = repOptions;
      } catch (e) {
        list.representative_selection = [];
      }
    }

    if (
      !list.company_phone_number_selection &&
      listSelectionNeedCall.company_phone_number_selection
    ) {
      const companyPhoneNumbersData = await getCompanyPhoneNumbersOptions();
      list.company_phone_number_selection = companyPhoneNumbersData;
    }

    if (!list.position_selection && listSelectionNeedCall.position_selection) {
      const positionsData = await getPositionsOptions();
      list.position_selection = positionsData;
    }

    if (!list.customer_selection && listSelectionNeedCall.customer_selection) {
      const clientsData = await getClientsOptions();
      list.customer_selection = clientsData;
    }

    setSelectionDataList(list);
  }, [
    selectionDataList,
    getDataByOrgType,
    listSelectionNeedCall,
    prefecturesData,
  ]);

  useEffect(() => {
    if (isPreview) return;
    getSelectionData();
  }, [getSelectionData, listSelectionNeedCall, isPreview]);

  const getIsAllowDownload = (url: string) => {
    if (!url) return false;
    const idAttachMent = getIdFromUrlAttactment(url);
    return !!allowDownLoad[idAttachMent];
  };

  const getValue = (values: any, key: string) => {
    let type =
      data?.app_parts.find((item) => item.id?.toString() === key.toString())
        ?.app_part_type || "";
    let isTable = false;
    if (!type) {
      let listChildItem: AppPartType[] = [];
      data?.app_parts.forEach((item) => {
        if (item.children) {
          listChildItem = [...listChildItem, ...item.children];
        }
      });
      type =
        listChildItem?.find(
          (item) => item.id?.toString() === getKey(key.toString()),
        )?.app_part_type || "";
      isTable = true;
    }
    switch (type) {
      case APP_PART_TYPES.ATTACHMENT:
        return isTable
          ? {
              type: APP_PART_TYPES.ATTACHMENT,
              is_allow_download_attachment: getIsAllowDownload(
                get(listFileUploaded, `[${key}][0].url`, ""),
              ),
              ...get(listFileUploaded, `[${key}][0]`, {}),
            }
          : listFileUploaded[key];
      case APP_PART_TYPES.CHECK_BOX:
      case APP_PART_TYPES.MULTI_CHOICE:
        return values[key].toString();
      case APP_PART_TYPES.ORGANIZATION_SELECTION:
      case APP_PART_TYPES.DIVISION_SELECTION:
      case APP_PART_TYPES.DEPARTMENT_SELECTION:
      case APP_PART_TYPES.BRANCH_SELECTION:
      case APP_PART_TYPES.WORKER_SELECTION:
      case APP_PART_TYPES.REPRESENTATIVE_SELECTION:
      case APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION:
      case APP_PART_TYPES.POSITION_SELECTION:
      case APP_PART_TYPES.CUSTOMER_SELECTION:
        if (!values[key].length) return "[]";
        if (typeof values[key][0] === "string") {
          const objectValue = values[key].map((x: string) => JSON.parse(x));
          return JSON.stringify(objectValue);
        }
        return JSON.stringify(values[key]);
      case APP_PART_TYPES.EMPLOYEE_INFO_SELECTION:
        return stringifyEmployeeInfoValue(values[key]);
      case APP_PART_TYPES.COMPANY_LOCATION_SELECTION:
        return values[key] !== undefined && values[key] !== null
          ? values[key].toString()
          : "";
      case APP_PART_TYPES.PRIMARY_COMPANY_NAME:
        return getPrimaryCompanyNameDisplayText();
      case APP_PART_TYPES.EMPLOYEE_SIGNATURE:
        return values[key] || "";
      default:
        if (isEmployeeInfoChildAppPartType(type)) {
          return stringifyEmployeeInfoChildFormValue(values[key]);
        }
        return values[key];
    }
  };

  useEffect(() => {
    if (data?.app_parts?.length && !dataSource) {
      const initDataSource: any = {};
      data?.app_parts.forEach((item) => {
        const dataItem: any = {};
        item.children?.forEach((child) => {
          dataItem[child.id || ""] = child.default_value || "";
        });
        const client_id = `${0}_${Date.now()}`;
        dataItem.key = `${item?.id}-${client_id}`;
        dataItem.client_id = client_id;
        dataItem.sort_index = 0;
        initDataSource[item.id || ""] = [dataItem];
      });
      setDataSource(initDataSource);
    }
  }, [data?.app_parts, dataSource]);

  const findDuplicateField = (values: any) => {
    if (!recordData || !recordData.length) return [];
    const existingValue: { [key: string]: string[] } = {};
    const prohibitDuplicateListId = dataApp.data?.app_parts
      .filter((part) => part.is_prohibit_duplicate_values)
      .map((listItem) => listItem.id);
    prohibitDuplicateListId?.forEach((record) => {
      if (record) {
        const listValue: string[] = [];
        recordData.forEach((data) => {
          const valueOfRecord = data.app_record_values.find(
            (item) => item.app_part_id.toString() === record.toString(),
          );
          listValue.push(valueOfRecord?.value || "");
        });
        existingValue[record] = listValue;
      }
    });
    const listDuplicateField: string[] = [];
    Object.keys(values).map((key) => {
      const fieldValue = values[key]?._isAMomentObject
        ? values[key]?.format()
        : values[key]?.toString();
      if (
        existingValue[key]?.includes(fieldValue) ||
        existingValue[key]?.find((v) =>
          isEqualTime(
            v,
            fieldValue,
            data?.app_parts?.find(
              (item) => item.id?.toString() === key.toString(),
            )?.app_part_type,
          ),
        )
      ) {
        listDuplicateField.push(key);
      }
    });
    return listDuplicateField;
  };

  const errorFromSelection = (values: any) => {
    const errors: Error[] = [];
    const listRequireSelection = data?.app_parts?.filter(
      (item) =>
        listSelection.indexOf(item.app_part_type) > -1 &&
        item.is_required_field,
    );
    listRequireSelection?.forEach((selection) => {
      if (!values[selection.id || ""]?.length) {
        errors.push({
          name: selection.id || "",
          errors: ["必要なフィルードです。ご入力ください。"],
        });
      }
    });
    return errors;
  };

  const getKey = (name: string) => {
    if (name.includes("-")) {
      return name.split("-")[2];
    }
    return name;
  };

  const getSortIndex = (name: string) => {
    if (name.includes("-")) {
      return name.split("-")[1].split("_")[0];
    }
    return "";
  };

  const isSelection = (key: string) => {
    const type =
      data?.app_parts?.find((item) => item.id?.toString() === key.toString())
        ?.app_part_type || "";
    return listSelection.includes(type);
  };

  const getTableId = (name: string) => {
    if (name.includes("-")) {
      return name.split("-")[0];
    }
    return name;
  };

  const handleUploadStatusChange = (fieldId: string, isUploading: boolean) => {
    if (isUploading) {
      uploadingFilesRef.current.add(fieldId);
    } else {
      uploadingFilesRef.current.delete(fieldId);
    }
    setIsUploadingFiles(uploadingFilesRef.current.size > 0);
  };

  const handleSubmit = (submitedValue: any) => {
    if (isUploadingFiles || isLoading) return;
    const values: { [key: string]: any } = {};

    Object.keys(submitedValue)
      .filter((key) => !submitedValue[key]?.blocks)
      .forEach((key) => {
        if (submitedValue[key] || isSelection(key)) {
          values[key] = submitedValue[key] || [];
        } else if (key.includes("-") && !submitedValue[key]) {
          values[key] = "";
        }
      });

    data?.app_parts?.forEach((item) => {
      if (
        [
          APP_PART_TYPES.CREATED_DATETIME,
          APP_PART_TYPES.UPDATED_DATETIME,
        ].includes(item.app_part_type as any)
      ) {
        if (item.id && !values[item.id]) {
          values[item.id] = moment().format();
        }
      }
    });
    const duplicateField = findDuplicateField(values);
    if (duplicateField.length) {
      const errorList = duplicateField.map((field) => {
        return {
          name: field,
          errors: ["この値は既に別のレコードに存在しています"],
        };
      });
      form.setFields(errorList);
      return;
    }

    const errorOfSelection = errorFromSelection(values);
    if (errorOfSelection.length) {
      form.setFields(errorOfSelection);
      return;
    }

    const submitValues = Object.keys(values)
      .reduce((prev: any, key) => {
        if (!Array.isArray(prev)) {
          prev = [];
        }

        if (isEmployeeInfoChildCurrentOptionsKey(key)) {
          return prev;
        }

        if (values[key] || key.includes("-")) {
          const valueToSubmit = getValue(values, key.toString());
          const attachmentItem = data?.app_parts
            ?.filter((item) => item.app_part_type === APP_PART_TYPES.ATTACHMENT)
            .map((item) => item.id?.toString());

          if (
            attachmentItem &&
            attachmentItem?.length > 0 &&
            attachmentItem.includes(key.toString()) &&
            valueToSubmit
          ) {
            const arrAttachment = (valueToSubmit || []).map(
              (itemValue: any) => {
                const is_allow_download_attachment = getIsAllowDownload(
                  itemValue.url,
                );
                const tableId = getTableId(key);
                const sortIndexTable = dataSource[tableId];
                const itemSourceData = sortIndexTable?.find((x: any) => {
                  const keyParts = key.split("-");
                  const keyJoin = keyParts[0] + "-" + keyParts[1];
                  return x.key === keyJoin;
                });
                const sort_index = itemSourceData?.sort_index;

                return {
                  app_part_id: getKey(key),
                  is_allow_download_attachment,
                  value: itemValue.url,
                  item_config_data: JSON.stringify({
                    client_id: itemSourceData?.client_id,
                  }),
                  ...(isNumber(sort_index) && { sort_index }),
                };
              },
            );
            return [...prev, ...arrAttachment];
          } else {
            let value = valueToSubmit;
            if (
              valueToSubmit &&
              valueToSubmit.type === APP_PART_TYPES.ATTACHMENT
            ) {
              value = valueToSubmit.url;
            }

            const tableId = getTableId(key);
            const sortIndexTable = dataSource[tableId];
            const itemSourceData = sortIndexTable?.find((x: any) => {
              const keyParts = key.split("-");
              const keyJoin = keyParts[0] + "-" + keyParts[1];
              return x.key === keyJoin;
            });
            const sort_index = itemSourceData?.sort_index;

            const currentOptions =
              values[getEmployeeInfoChildCurrentOptionsKey(key)];

            return [
              ...prev,
              {
                app_part_id: getKey(key),
                value: value,
                ...(currentOptions
                  ? {
                      current_options:
                        ensureCurrentOptionsJson(currentOptions) || "[]",
                    }
                  : {}),
                is_allow_download_attachment:
                  valueToSubmit?.is_allow_download_attachment,
                item_config_data: JSON.stringify({
                  client_id: itemSourceData?.client_id,
                }),
                ...(isNumber(sort_index) && { sort_index }),
              },
            ];
          }
        }

        return prev;
      }, [])
      .filter((item: any) => item?.value !== undefined);

    const labelItem = data?.app_parts?.filter(
      (item) => item.app_part_type === APP_PART_TYPES.LABEL,
    );
    if (labelItem?.length) {
      labelItem?.forEach((item) => {
        submitValues.push({
          app_part_id: item.id || "",
          value: item?.default_value || "",
        });
      });
    }

    mutate(
      {
        payload: {
          app_record_values_data: submitValues,
        },
      },
      {
        onSuccess() {
          navigate(-1);
        },
        onError(e: any) {
          notification["error"]({
            message:
              e?.response?.data?.message || "Bizシートを編集する際のエラー",
          });
        },
      },
    );
  };

  const createDefaultValueForTable = (
    item: AppPartType,
    formDefaultValue: Record<string, unknown>,
  ) => {
    item?.children?.forEach((child) => {
      if (child.default_value) {
        const name = `${item.id}-1-${child.id}`;
        const defaultValue = getDefaultValueFromAppPartType(
          child.default_value,
          child.app_part_type,
        );
        formDefaultValue[name] = defaultValue;
      }
      if (
        child.calc_type === APP_PART_TYPES.DATE ||
        child.calc_type === APP_PART_TYPES.TIME ||
        child.calc_type === "date_time"
      ) {
        const name = `${item.id}-1-${child.id}`;
        const defaultValue = getDefaultValueFromAppPartType(
          new Date().toString(),
          child.app_part_type,
        );
        formDefaultValue[name] = defaultValue;
      }
    });
  };

  const getDefaultValueForSlection = (
    appPartType: string,
    config?: ItemConfigDataType,
  ) => {
    switch (appPartType) {
      case APP_PART_TYPES.ORGANIZATION_SELECTION:
        if (config?.default_organizations) {
          return config?.default_organizations?.map((v) => v.id.toString());
        }
        return [];
      case APP_PART_TYPES.DIVISION_SELECTION:
        if (config?.default_divisions) {
          return config?.default_divisions?.map((v) => v.id.toString());
        }
        return [];
      case APP_PART_TYPES.DEPARTMENT_SELECTION:
        if (config?.default_departments) {
          return config?.default_departments?.map((v) => v.id.toString());
        }
        return [];
      case APP_PART_TYPES.BRANCH_SELECTION:
        if (config?.default_branchs) {
          return config?.default_branchs?.map((v) => v.id.toString());
        }
        return [];
      case APP_PART_TYPES.WORKER_SELECTION:
        if (config?.default_workers) {
          return config?.default_workers?.map((v) => v.id.toString());
        }
        return [];
      default:
        return null;
    }
  };

  const createDefaultValue = () => {
    const formDefaultValue: Record<string, unknown> = {};
    data?.app_parts?.forEach((item) => {
      if (item.app_part_type === APP_PART_TYPES.TABLE) {
        createDefaultValueForTable(item, formDefaultValue);
      }
      let itemDefaultValue =
        item?.default_value ||
        getDefaultValueForSlection(item.app_part_type, item.item_config_data);
      if (!itemDefaultValue && item.calc_type) {
        if (
          item.calc_type === APP_PART_TYPES.DATE ||
          item.calc_type === APP_PART_TYPES.TIME ||
          item.calc_type === "date_time"
        ) {
          itemDefaultValue = new Date().toString();
        }
      }

      if (
        [
          APP_PART_TYPES.CREATED_DATETIME,
          APP_PART_TYPES.UPDATED_DATETIME,
        ].includes(item.app_part_type as any)
      ) {
        itemDefaultValue = new Date().toString();
      }
      if (item.id && itemDefaultValue) {
        formDefaultValue[item.id] = getDefaultValueFromAppPartType(
          itemDefaultValue,
          item.app_part_type,
          item.item_config_data,
        );
      } else if (
        item.app_part_type === APP_PART_TYPES.CHECK_BOX ||
        item.app_part_type === APP_PART_TYPES.MULTI_CHOICE
      ) {
        formDefaultValue[item?.id || ""] =
          item?.item_config_data?.options
            ?.filter((x) => x.default_checked)
            ?.map((x) => x.text) || [];
      }
    });
    return formDefaultValue;
  };

  const getDefaultValueFromAppPartType = (
    value: string | SelectionValue[] | string[],
    appPartType: string,
    config?: ItemConfigDataType,
  ) => {
    switch (appPartType) {
      case APP_PART_TYPES.DATE:
        return moment(value as string).date()
          ? moment(value as string)
          : moment(value as string, "YYYY/MM/DD");
      case APP_PART_TYPES.TIME:
        return moment(value as string).date()
          ? moment(value as string)
          : moment(value as string, "HH:mm");
      case APP_PART_TYPES.DATE_AND_TIME:
        return moment(value as string);
      case APP_PART_TYPES.MULTI_CHOICE:
        return Array.from(value as string);
      case APP_PART_TYPES.CHECK_BOX:
        return (
          config?.options
            ?.filter((op) => op.default_checked)
            .map((op) => op.text) || []
        );
      case APP_PART_TYPES.ORGANIZATION_SELECTION:
      case APP_PART_TYPES.ATTACHMENT:
      case APP_PART_TYPES.DIVISION_SELECTION:
      case APP_PART_TYPES.DEPARTMENT_SELECTION:
      case APP_PART_TYPES.BRANCH_SELECTION:
      case APP_PART_TYPES.WORKER_SELECTION:
      case APP_PART_TYPES.COMPANY_LOCATION_SELECTION:
      case APP_PART_TYPES.REPRESENTATIVE_SELECTION:
      case APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION:
      case APP_PART_TYPES.POSITION_SELECTION:
      case APP_PART_TYPES.EMPLOYEE_INFO_SELECTION:
      case APP_PART_TYPES.CUSTOMER_SELECTION:
        return value;
      case APP_PART_TYPES.CREATED_DATETIME:
      case APP_PART_TYPES.UPDATED_DATETIME:
        return moment(value as string);
      default:
        return value.toString();
    }
  };

  const handleAddRow = useCallback(
    (id: string) => {
      if (dataSource) {
        const newDataSource = { ...dataSource };
        const defaultValueForNewRow: { name: string; value: any }[] = [];
        const tableSource = newDataSource[id];
        if (tableSource) {
          const listChild = data?.app_parts?.find(
            (item) => item.id?.toString() === id,
          );
          const dataItem: any = {};
          listChild?.children?.forEach((child) => {
            dataItem[child.id || ""] = "";
            if (child.default_value) {
              defaultValueForNewRow.push({
                name: `${listChild?.id}-${tableSource.length + 1}-${child.id}`,
                value:
                  getDefaultValueFromAppPartType(
                    child.default_value,
                    child.app_part_type,
                  ) || "",
              });
            }
          });

          const client_id = `${0}_${Date.now()}`;
          dataItem.key = `${id}-${client_id}`;
          dataItem.client_id = client_id;
          dataItem.sort_index = 0;
          tableSource.push(dataItem);
        }
        setDataSource(newDataSource);
        setTimeout(() => {
          defaultValueForNewRow.forEach((rowValue) => {
            form.setFieldValue(rowValue.name, rowValue.value);
          });
        }, 100);
      }
    },
    [dataSource, data?.app_parts, form],
  );

  const listAppPartFormula = data?.app_parts?.filter(
    (ap) => ap?.app_part_type === APP_PART_TYPES.CALCULATED,
  );

  const handleOnChangeForm = () => {
    const oldFieldsValue = form.getFieldsValue();
    const newFieldValues: Record<string, unknown> = {};
    data?.app_parts?.forEach((apItem) => {
      newFieldValues[apItem?.field_code as string] =
        apItem?.app_part_type === APP_PART_TYPES.NUMBER
          ? Number(oldFieldsValue?.[apItem?.id as string])
          : oldFieldsValue?.[apItem?.id as string];
    });

    const { evaluateFormula } = calculatedValue({
      fieldValues: newFieldValues,
    });

    const newValues: any = {};
    if (listAppPartFormula?.length) {
      for (const appItem of listAppPartFormula) {
        if (appItem?.formula) {
          const valueCalculated = evaluateFormula(appItem?.formula);
          newValues[appItem?.id || ""] = valueCalculated;
        }
      }
      form.setFieldsValue({
        ...oldFieldsValue,
        ...newValues,
      });
    }
  };

  const renderCol = (itemLayouts: {
    items: any[];
    maxBottomY: number;
    marginTop: number;
    minY: number;
  }) => {
    let preMaxRightX = 0;
    return itemLayouts.items.map((layoutCol, indexCol) => {
      const { maxRightX, minX } = getMinXAndMarginLeft(layoutCol);
      const marginRight = minX - preMaxRightX;
      preMaxRightX = maxRightX;
      const col = maxRightX - minX;
      const row =
        layoutCol.length === 1 ? 1 : itemLayouts.maxBottomY - itemLayouts.minY;
      return (
        <span key={indexCol}>
          <div
            style={{
              marginLeft: marginRight * COLUMN_WIDTH,
              display: "grid",
              gridTemplateColumns: `repeat(${col}, minmax(${COLUMN_WIDTH}px, auto))`,
              gridTemplateRows: `repeat(${row}, minmax(${ROW_HEIGHT}px, auto))`,
            }}
            className="container-col"
          >
            {layoutCol
              .sort(
                (a: AppPartType, b: AppPartType) =>
                  a.item_config_data.y - b.item_config_data.y,
              )
              .map((item: AppPartType) => {
                const { w, h, x, y, i } = item.item_config_data;
                const startCol = x - minX + 1;
                const startRow = y - itemLayouts.minY + 1;
                return (
                  <div
                    key={i}
                    style={{
                      gridColumn: `${startCol} / span ${w}`,
                      gridRow: `${startRow} / span ${h}`,
                    }}
                  >
                    {renderField(item)}
                  </div>
                );
              })}
          </div>
        </span>
      );
    });
  };

  const renderField = (item: AppPartType) => {
    const isHiddleLabel = item?.is_hide_name;
    const labelText = isPreview ? item?.name : item?.label_text;
    const nameItem = item.id?.toString();
    const isAllowViewField =
      item?.current_detail_permissions?.specified_app_part_read ||
      item?.current_detail_permissions?.specified_app_part_edit;
    const style = {
      width: (item.item_config_data.w - 1) * COLUMN_WIDTH,
    };
    if (!isAllowViewField) {
      if (
        data?.current_detail_permissions?.specified_app_edit ||
        data?.current_detail_permissions?.specified_app_delete
      ) {
        return (
          <div className="column-no-permission" key={item.id} style={style}>
            <Form.Item
              label={isHiddleLabel ? <div></div> : labelText}
              name={nameItem}
            >
              <div className="text">閲覧権限がありません</div>
            </Form.Item>
          </div>
        );
      } else {
        return <div key={item.id} style={style} />;
      }
    }
    const commonProps = {
      key: item.id,
      nameItem: nameItem || "",
      preview: !!isPreview,
      item,
      style,
    };

    switch (item.app_part_type) {
      case APP_PART_TYPES.TEXT:
        return (
          <Text
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.ATTACHMENT:
        return (
          <div
            key={item.id}
            style={style}
            id={item.id}
            className="type-attachment"
          >
            <Attachment
              labelText={labelText}
              form={form}
              isDisable={!!isPreview}
              isHiddleLabel={isHiddleLabel}
              listFileUploaded={listFileUploaded}
              setListFileUploaded={setListFileUploaded}
              isAllowEditColumn={true}
              setAllowDownLoad={setAllowDownLoad}
              allowDownLoad={allowDownLoad}
              onUploadStatusChange={(isUploading) =>
                handleUploadStatusChange(item.id?.toString() || "", isUploading)
              }
              {...commonProps}
              className={getFieldClassName(commonProps.nameItem)}
            />
          </div>
        );
      case APP_PART_TYPES.TEXT_AREA:
        return (
          <TextAreaCustom
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.LABEL:
        return <LabelField {...commonProps} />;
      case APP_PART_TYPES.RADIO_BUTTON:
        return <RadioButton {...commonProps} />;
      case APP_PART_TYPES.DATE:
        return (
          <DateCustom
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.TIME:
        return (
          <TimeCustom
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.NUMBER:
        return (
          <div key={item.id} style={style} id={item.id}>
            <InputNumber
              {...commonProps}
              className={getFieldClassName(commonProps.nameItem)}
            />
          </div>
        );
      case APP_PART_TYPES.RICH_TEXT:
        return (
          <div key={item.id} style={style} className="rich-text" id={item.id}>
            <RichText
              {...commonProps}
              className={getFieldClassName(commonProps.nameItem)}
            />
          </div>
        );
      case APP_PART_TYPES.CHECK_BOX:
        return (
          <CheckBox
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.LINK:
        return (
          <LinkCusTom
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.HORIZONTAL_BORDER:
        return (
          <div key={item.id}>
            <HorizontalBorder {...commonProps} />
          </div>
        );
      case APP_PART_TYPES.VERTICAL_BORDER:
        return (
          <div key={item.id}>
            <VerticalBorder {...commonProps} />
          </div>
        );
      case APP_PART_TYPES.BLANK_SPACE:
        return <div key={item.id} style={style}></div>;
      case APP_PART_TYPES.DATE_AND_TIME:
        return (
          <DateAndTime
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.DROPDOWN:
        return (
          <Dropdown
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.MULTI_CHOICE:
      case APP_PART_TYPES.RELATED_RECORDS:
        return (
          <CommonChoose
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.TABLE:
        return (
          <TableCusTom
            {...commonProps}
            form={form}
            parentRecord={item}
            setEditorState={setEditorState}
            editorState={editorState}
            listFileUploaded={listFileUploaded}
            setListFileUploaded={setListFileUploaded}
            setAllowDownLoad={setAllowDownLoad}
            allowDownLoad={allowDownLoad}
            selectionDataList={selectionDataList}
            dataSourceAllTable={dataSource}
          />
        );
      case APP_PART_TYPES.CREATED_BY:
      case APP_PART_TYPES.UPDATED_BY:
      case APP_PART_TYPES.CREATED_DATETIME:
      case APP_PART_TYPES.UPDATED_DATETIME:
      case APP_PART_TYPES.RECORD_NUMBER:
        return <AutoFill {...commonProps} />;
      case APP_PART_TYPES.PRIMARY_COMPANY_NAME:
        return (
          <AutoFill {...commonProps}>
            {getPrimaryCompanyNameDisplayText()}
          </AutoFill>
        );
      case APP_PART_TYPES.ORGANIZATION_SELECTION:
      case APP_PART_TYPES.DIVISION_SELECTION:
      case APP_PART_TYPES.DEPARTMENT_SELECTION:
      case APP_PART_TYPES.BRANCH_SELECTION:
      case APP_PART_TYPES.WORKER_SELECTION:
      case APP_PART_TYPES.COMPANY_LOCATION_SELECTION:
      case APP_PART_TYPES.REPRESENTATIVE_SELECTION:
      case APP_PART_TYPES.COMPANY_PHONE_NUMBER_SELECTION:
      case APP_PART_TYPES.POSITION_SELECTION:
      case APP_PART_TYPES.EMPLOYEE_INFO_SELECTION:
      case APP_PART_TYPES.CUSTOMER_SELECTION:
        return (
          <CommonSelection
            selectionDataList={selectionDataList}
            {...commonProps}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      case APP_PART_TYPES.CALCULATED:
        return <Calculated {...commonProps} />;
      case APP_PART_TYPES.EMPLOYEE_SIGNATURE:
        return (
          <EmployeeSignature
            {...commonProps}
            form={form}
            selectionDataList={selectionDataList}
            allAppParts={data?.app_parts}
            className={getFieldClassName(commonProps.nameItem)}
          />
        );
      default:
        if (isEmployeeInfoChildAppPartType(item.app_part_type)) {
          return (
            <EmployeeInfoChildField
              {...commonProps}
              appParts={data?.app_parts}
              form={form}
            />
          );
        }
        return <></>;
    }
  };

  if (isLoading || !data?.app_parts) {
    return <Loading />;
  }

  return (
    <Styles className={`scroll_internal ${isPreview ? "mode_preview" : ""}`}>
      {!isPreview && (
        <StyledButton>
          <Button
            className={`mr-2 ${
              buttonState === "error" ? "submit-btn-error" : ""
            }`}
            type="primary"
            onClick={() => {
              form.submit();
              markSubmit();
            }}
            disabled={isUploadingFiles || isLoading}
            style={{
              height: 40,
              ...getButtonStyle(),
            }}
          >
            保存
          </Button>
          <Button
            type="primary"
            onClick={() => navigate(-1)}
            style={{
              height: 40,
              backgroundColor: MENU_COLORS.DELETE_ALL,
              borderColor: "none",
            }}
          >
            キャンセル
          </Button>
        </StyledButton>
      )}
      <Form
        form={form}
        layout="vertical"
        name="basic"
        initialValues={createDefaultValue()}
        onFinish={handleSubmit}
        onChange={handleOnChangeForm}
        onFinishFailed={({ values }) => errorFromSelection(values)}
        autoComplete="off"
        style={{ height: "auto" }}
        disabled={!!isPreview}
        {...registerFormWatcher()}
      >
        {newLayout.map((layoutRows, rowIndex) => (
          <div
            key={rowIndex}
            style={{
              marginTop: layoutRows.marginTop * ROW_HEIGHT,
              display: "flex",
            }}
          >
            {renderCol(layoutRows)}
          </div>
        ))}
      </Form>
      <br />
    </Styles>
  );
};

export default AppCreate;
